import type { Store } from '@/types';

import { createContext } from '../utilities/context';

// We can't access the store directly within services else we would create a circular dependencies.
export const { setContext: setStore, getContext: getStore } = createContext<Store>();
